import React, { useEffect, useState } from "react";
import { Link, Redirect, Route, Switch } from "react-router-dom";
import { kebabCase } from "lodash";
import { useSelector } from "react-redux";
import KdsService from "../../services/KdsService";
import Expo from "./Expo";
import Kitchen from "./Kitchen";
import KdsStation from "./KdsStation";
import Ingredients from "./Ingredients";

const defaultStations = [
  {
    id: "expo",
    name: "Expo",
  },
  {
    id: "kitchen",
    name: "Kitchen",
  }
];

const Kds = ({ location, match }) => {
  const [kdsStations, setKdsStations] = useState([]);
  const { pathname } = location;
  const restaurantId = useSelector((state) => state.admin);

  useEffect(() => {
    KdsService.getAllKdsStations(restaurantId).then((data) => {
      setKdsStations(defaultStations.concat(data).concat(  {
        id: "ingredients",
        name: "Ingredients",
      }));
    });
  }, []);

  return (
    <>
      <div className="sub_head">
        {kdsStations.map((item, i) => {
          return (
            <div
              key={i}
              className={
                pathname.includes(kebabCase(item.name))
                  ? "activesub_nav"
                  : "sub_nav"
              }
            >
              <Link to={"/kds/" + kebabCase(item.name)}>{item.name}</Link>
            </div>
          );
        })}
      </div>
      <Switch>
        <Route exact path={`${match.path}/expo`}>
          <Expo />
        </Route>
        <Route exact path={`${match.path}/kitchen`}>
          <Kitchen />
        </Route>
        <Route exact path={`${match.path}/ingredients`}>
          <Ingredients />
        </Route>
        <Route path={`${match.path}/:stationName`}>
          <KdsStation />
        </Route>
        <Redirect to={`${match.path}/expo`} />
      </Switch>
    </>
  );
};

export default Kds;
